export default __webpack_public_path__ + "static/tech-29d5c244830ef1a57a76eec2fedf33cc.svg";